import React from 'react';
import { render } from 'react-dom';
import JobSearch from './components/JobSearchApp/JobFilter';
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";

//ReactDOM.render(<A pp />,document.getElementById('root'));
render(
  <Router>
    <Routes>
      <Route exact path="/jobsearch" element={<JobSearch />} />
    </Routes>
  </Router>,
  document.getElementById('root')
);
